import * as React from 'react';
import './index.scss';
import { Tabs } from '@roo/roo';
import MessageList from './messageList';
import { MessageType } from './api';

const { Pane: TabPane } = Tabs;

const MessageCenter: React.FC = () => (
    <div className="page message-center">
        <h1>消息中心</h1>
        <Tabs type="line" defaultValue="tab1">
            <TabPane label="运营消息" name="tab1">
                <MessageList msgType={MessageType.OPERATIONAL} />
            </TabPane>
            <TabPane label="平台消息" name="tab2">
                <MessageList msgType={MessageType.PLATFORM} />
            </TabPane>
        </Tabs>
    </div>
);

export default MessageCenter;
